import {SET_PREFERENCES} from './types';

export const setPreferences = payload => ({
  type: SET_PREFERENCES,
  payload,
});
